<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="table-wrapper" :style="{ height: '100%', 'overflow-y': 'auto' }">
    <v-data-table hide-default-footer ref="dataTable" height="100%" class="elevation-0 tt" :headers="headers"
      :items="tableItems" :items-per-page="data.length"></v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      default: () => [],
      required: true,
      type: Array,
    },
    data: {
      default: () => [],
      required: true,
      type: Array,
    },
    renderCount: {
      default: 10,
      required: true,
      type: Number,
    },
    searchModel: {
      default: '',
      required: false,
      type: String,
    },
  },
  components: {},
  data() {
    return {
      items: [],
      tableItems: [],
      currentIndex: 0,
    };
  },
  computed: {
    chunkedArray: function () {
      const transformedArr = [...this.chunkArray(this.data, 50)]?.map((arr, index) => {
        return [...arr]?.map((item) => ({ ...item, parent_index: index }));
      });
      return transformedArr;
    },
  },
  methods: {
    chunkArray: function (array, chunkSize = 50) {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    },
    handleScroll(e) {
      const el = e.target;
      const scrollBottom = el.scrollTop + el.clientHeight;
      const isBottom = scrollBottom >= el.scrollHeight - 1;
      const isTop = el.scrollTop <= 3;
      if (isBottom) {
        if (this.currentIndex !== this.chunkedArray?.length - 1) {
          this.currentIndex += 1;
          el.scrollTop = el.scrollHeight / 3;
        }
      }
      if (isTop && this.currentIndex > 1) {
        this.currentIndex -= 1;
        el.scrollTop = el.scrollHeight / 4;
      }
    },
  },
  mounted() {
    // Add scroll event listener after rendering
    this.$nextTick(() => {
      const tableBody = this.$refs.dataTable?.$el?.querySelector('.v-data-table__wrapper');
      if (tableBody) {
        tableBody.addEventListener('scroll', this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    const tableBody = this.$refs.dataTable?.$el?.querySelector('.v-data-table__wrapper');
    if (tableBody) {
      tableBody.removeEventListener('scroll', this.handleScroll);
    }
  },
  watch: {
    currentIndex: {
      handler(currentVal, oldVal) {
        if (currentVal > oldVal) {
          const newArr = [...this.tableItems, ...this.chunkedArray[currentVal]]?.filter(
            ({ parent_index }) => parent_index === oldVal || parent_index === currentVal,
          );
          this.tableItems = [...newArr];
        } else if (currentVal < oldVal) {
          const newArr = [...this.chunkedArray[currentVal - 1], ...this.chunkedArray[currentVal]];
          this.tableItems = [...newArr];
        }
      },
      immediate: true,
    },
    chunkedArray: {
      handler(currentVal) {
        if (currentVal?.length) {
          this.tableItems = currentVal[this.currentIndex];
        } else this.tableItems = [];
      },
      immediate: true,
    },
    data: {
      handler() {
        this.currentIndex = 0;
        const tableBody = this.$refs.dataTable?.$el?.querySelector('.v-data-table__wrapper');
        tableBody.scrollTop = 0;
        this.tableItems = this.chunkedArray[this.currentIndex];
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.tt {
  height: 100%;

  tr:nth-of-type(even) {
    background-color: var(--background-color) !important;
  }
}
</style>
